import { LOGO_URL } from "../lib/constants";

/**
 * Logo displays the Zapperus artwork.
 * The site background (#FCFAF7) matches the logo's own off-white,
 * so no blend mode is needed for a seamless look.
 */
export default function Logo({ height = 44, className = "" }) {
    return (
        <img
            src={LOGO_URL}
            alt="Zapperus"
            style={{ height }}
            className={`w-auto object-contain select-none ${className}`}
            data-testid="brand-logo"
        />
    );
}
